import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Navbar, Sidebar } from '../../components';
import GeoMapComponent from './GeoMapComponent';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import { dummyUserImage } from '../../utils/system';
import SelectInput from '../../components/muiCustomized/CustomMenuSelect';

function ProfileUpdateRequests() {
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [members, setMembers] = useState([]);
  const { activeWorkspace } = useContext(UserContext);
  const history = useHistory();

  const transformMemberData = (originalData) => {
    try {
      const user = originalData.user || {};
      const loc = user.userLocation || {};
      const lat = Number(loc.latitude);
      const lng = Number(loc.longitude);

      // Skip members without a usable location instead of dropping a marker at
      // (0, 0) — that previously stacked everyone off the coast of Africa.
      if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) {
        return null;
      }

      const location = loc.formattedAddress
        || [loc.locality, loc.administrativeAreaLevel1, loc.country].filter(Boolean).join(', ');

      return {
        id: originalData?.id || 0,
        lat,
        lng,
        firstName: user.firstName || 'Unknown',
        lastName: user.lastName || 'User',
        profilePicture:
            typeof user.profilePicture === 'string' && user.profilePicture.trim() !== ''
              ? user.profilePicture
              : dummyUserImage,
        designation: user.designation || originalData?.accountType || 'Team Member',
        department: user.department || '',
        email: user.email || '',
        phone: user.phone || user.workPhone || user.phoneNumber || '',
        location: location || '',
      };
    } catch (error) {
      console.error('Error transforming member data:', error);
      return null;
    }
  };

  const fetchGeoMapMembers = async () => {
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.geoMapMembers(activeWorkspace.id),
      params: {
        teamId: selectedTeam,
      },
    });

    if (response.success) {
      const members = response.data.members
        .map(transformMemberData)
        .filter(Boolean);
      setMembers(members);
    }
  };

  const fetchTeams = async () => {
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.getTeams(activeWorkspace.id),
    });

    if (response.success) {
      const teams = response.data.teams.map((team) => ({
        id: team.id,
        value: team.id,
        text: team.name,
      }));
      setTeams(teams);
    }
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  useEffect(() => {
    fetchGeoMapMembers();
  }, [selectedTeam]);

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header insights">
          <div className="d-flex align-c width-full justify-content-sm-between mb-4">
            <div className="org-page-caption">
              Workspace Geo Map
            </div>
            <div className="flex-row gap-2">
              <SelectInput
                id="team"
                menuItems={teams}
                menuWidth="202px"
                placeholder="Select Team"
                value={selectedTeam}
                handleForm={(e) => setSelectedTeam(e.target.value)}
              />
            </div>
          </div>
          <div
            style={{
              height: 'calc(100vh - var(--header-height, 56px) - 100px)',
              minHeight: '420px',
              borderRadius: '12px',
              overflow: 'hidden',
            }}
          >
            <GeoMapComponent
              members={members}
              handleClose={() => history.goBack()}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileUpdateRequests;
